import PropTypes from 'prop-types'
import { LISTVIEW, DETAILVIEW } from '../constants'

export default PropTypes.oneOf([LISTVIEW, DETAILVIEW])
